// One way to write a phone number everywhere in the app: (775) 857-4500.
// Ten digits (or eleven with a leading 1) come out in that shape, with any extension
// kept ("x204"). Anything else — a foreign number, a partial, free text — is left as
// typed rather than mangled. Safe on null/undefined (returns '').
export function formatPhone(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s) return '';
  // Pull an extension off the end: "ext 204", "x204", "#204".
  const m = s.match(/^(.*?)(?:\s*(?:ext\.?|x|#)\s*(\d{1,6}))\s*$/i);
  const main = m ? m[1] : s;
  const ext = m ? m[2] : null;
  let d = main.replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1);
  if (d.length !== 10) return s;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}${ext ? ' x' + ext : ''}`;
}
export default formatPhone;
